import { ECountry } from 'App/i18n/i18n.types';

import {
  NECorreoArgClasicoDomicilio,
  NECorreoArgClasicoSucursal,
  NECorreoArgExpresoDomicilio,
  NECorreoArgExpresoSucursal,
  NEEnviaDhlExpress,
  NEEnviaDhlGround,
  NEEnviaDhlInternationalExpress,
  NEEnviaFedexExpress,
  NEEnviaFedexGround,
  NEEnviaFedexInternationalGround,
  NEEnviaNoventa9MinutosLocalNextDay,
  NEEnviaNoventa9MinutosNextDay,
  NEEPickDomicilio,
  NEEPickOcaDomicilio,
  NEJadLog,
  NEJadLogCom,
  NELoggiEconomic,
  NELoggiEconomicCollect,
  NELoggiExpress
} from '../freight-type';

export const BR_MINIMUM_AMOUNT_PRE_PAID = 4;
export const AR_MINIMUM_AMOUNT_PRE_PAID = 50;
export const MX_MINIMUM_AMOUNT_PRE_PAID = 7;

export const DISPATCH_ON_SUCCESS_COUNTRIES = [ECountry.MEXICO];

const NE_PREMIUM_DELIVERY_OPTIONS_MX = [
  NEEnviaFedexGround,
  NEEnviaFedexExpress,
  NEEnviaDhlGround,
  NEEnviaDhlExpress,
  NEEnviaNoventa9MinutosLocalNextDay,
  NEEnviaNoventa9MinutosNextDay,
  NEEnviaFedexInternationalGround,
  NEEnviaDhlInternationalExpress
];

const NE_PREMIUM_DELIVERY_OPTIONS_BR = [
  NELoggiExpress,
  NELoggiEconomic,
  NELoggiEconomicCollect,
  NEJadLog,
  NEJadLogCom
];

const NE_PREMIUM_DELIVERY_OPTIONS_AR = [
  NEEPickDomicilio,
  NEEPickOcaDomicilio,
  NECorreoArgClasicoDomicilio,
  NECorreoArgClasicoSucursal,
  NECorreoArgExpresoDomicilio,
  NECorreoArgExpresoSucursal
];

export const NE_PREMIUM_DELIVERY_OPTIONS: string[] = [
  ...NE_PREMIUM_DELIVERY_OPTIONS_MX,
  ...NE_PREMIUM_DELIVERY_OPTIONS_BR,
  ...NE_PREMIUM_DELIVERY_OPTIONS_AR
];
